import {
  range
} from "lodash"
import {
  getDay
} from "../../utils/date"
import { testClientList } from "./test-client"


const clientLength = testClientList.length
const length = 30
const dayRange = range(length).reverse()

export const __statistics__invoices = {
  "data": dayRange.map(i => {
    const client = testClientList[i % clientLength]
    const totalAmt = 10000000 * (1 + client.val + (i / 100))
    return {
      supByrType: "sales",
      "clientIdx": client.idx,
      "date": getDay(i),
      totalAmt,
      "supplyAmt": totalAmt - (totalAmt * 0.9),
      "taxAmt": totalAmt * 0.9,
      client
    }
  }),
  "metadata": {
    "offset": 0,
    "search": null,
    "order": null,
    "range": {
      "writeDate": {
        "from": getDay(29),
        "to": getDay(0)
      }
    }
  }
}